class JobPipelineServiceClass {
  constructor() {
    this.idToPipelineMap = {};
  }

  registerPipeline(id, pipeline) {
    this.idToPipelineMap[id] = pipeline;
  }

  getPipelineById(id) {
    return this.idToPipelineMap[id];
  }
}

export const JobPipelineService = new JobPipelineServiceClass();
